import { render, staticRenderFns } from "./PhotoFeedSingle.vue?vue&type=template&id=6d27e212&scoped=true"
import script from "./PhotoFeedSingle.vue?vue&type=script&lang=js"
export * from "./PhotoFeedSingle.vue?vue&type=script&lang=js"
import style0 from "./PhotoFeedSingle.vue?vue&type=style&index=0&id=6d27e212&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d27e212",
  null
  
)

export default component.exports